import React, { useEffect, useState } from "react";
import { ROLE } from "../Enum";

const Avatar = (props) => {
  const [frame, setFrame] = useState("coach");

  useEffect(() => {
    console.log("props.roleId", props.roleId);
    if (props.roleId !== ROLE.coach && !props.showBadge) {
      if (props.currentLevel === 0) {
        setFrame("frame");
      }
      if (props.currentLevel === 1) {
        setFrame("bronze");

      }
      if (props.currentLevel === 2) {
        setFrame("silver");

      }
      if (props.currentLevel === 3) {
        setFrame("gold");

      }
      if (props.currentLevel === 4) {
        setFrame("platinum");

      }
    }

  }, [props.currentLevel]);

  return (
    <div className={props.className}>
      <div className={"avatar-wrapper " + frame}>
        <div className="avatar-wrapper-border">
          <div className="avatar-profile d-flex align-items-center justify-content-center"
            style={{ backgroundImage: 'url(' + props.profileImage + ')' }}>
            {Boolean(props.profileImage) && props.profileImage !== "NA"
              ? <img src={props.profileImage} style={{ width: '100%' }} alt="" />
              : props.firstName && props.firstName[0].toUpperCase() + "" + props.lastName[0].toUpperCase()}
          </div>
        </div>
        <div className={"badge-frame " + frame}></div>
      </div>
    </div>
  );
};

export default Avatar;
